import { Link } from "react-router-dom";
import { ChevronDown } from "lucide-react";
import { APPS } from "@/lib/apps";
import { useAuth } from "@/lib/auth/AuthProvider";
import { useFounder } from "@/lib/founder/useFounder";
import StreakBadge from "@/components/streaks/StreakBadge";
import AppSwitcher from "@/components/AppSwitcher";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const SiteHeader = () => {
  const { session, signOut } = useAuth();
  const { isFounder } = useFounder();

  return (
    <header className="sticky top-0 z-40 border-b border-border/60 bg-background/80 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="w-full pl-4 pr-6 sm:pl-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center" aria-label="wavlynq home">
          <span className="text-2xl font-bold tracking-tight lowercase bg-wavlynq-gradient bg-clip-text text-transparent">
            wavlynq
          </span>
        </Link>
        <nav className="flex items-center gap-6 text-sm">
          <DropdownMenu>
            <DropdownMenuTrigger className="inline-flex items-center gap-1 text-muted-foreground hover:text-foreground transition-colors outline-none">
              Apps
              <ChevronDown className="h-3.5 w-3.5" aria-hidden />
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-56">
              {APPS.map((a) => (
                <DropdownMenuItem key={a.id} asChild>
                  <Link to={a.href} className="flex items-center gap-2 cursor-pointer">
                    <img src={a.icon} alt="" className="h-4 w-4" />
                    <span className="flex-1">{a.name}</span>
                  </Link>
                </DropdownMenuItem>
              ))}
            </DropdownMenuContent>
          </DropdownMenu>
          {session ? (
            <>
              <AppSwitcher />
              <StreakBadge />
              <Link to="/discover" className="text-muted-foreground hover:text-foreground transition-colors">
                Discover
              </Link>
              <Link to="/matches" className="text-muted-foreground hover:text-foreground transition-colors">
                Matches
              </Link>
              <Link to="/mentors" className="text-muted-foreground hover:text-foreground transition-colors">
                Mentors
              </Link>
              <Link to="/events" className="text-muted-foreground hover:text-foreground transition-colors">
                Events
              </Link>
              <Link to="/messages" className="text-muted-foreground hover:text-foreground transition-colors">
                Messages
              </Link>
              <Link to="/raela" className="text-muted-foreground hover:text-foreground transition-colors">
                RAELA
              </Link>
              <Link to="/contribute" className="text-primary hover:text-primary/80 transition-colors">
                Contribute
              </Link>
              <Link to="/account" className="text-muted-foreground hover:text-foreground transition-colors">
                Account
              </Link>
              {isFounder && (
                <Link to="/founder" className="text-amber-500 hover:text-amber-400 transition-colors">
                  Founder
                </Link>
              )}
              <button
                type="button"
                onClick={signOut}
                className="text-muted-foreground hover:text-foreground transition-colors"
              >
                Sign out
              </button>
              <Link to="/partner-access" className="font-bold text-primary hover:underline">
                Partner access
              </Link>
            </>
          ) : (
            <>
              <Link to="/partner-access" className="font-bold text-primary hover:underline">
                Partner access
              </Link>
              <Link
                to="/auth"
                className="rounded-full bg-foreground text-background px-4 py-1.5 text-xs font-medium hover:opacity-90 transition-opacity"
              >
                Sign in
              </Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
};

export default SiteHeader;
